/**
 * Visually hidden link that becomes visible on focus, allowing keyboard
 * and screen-reader users to jump directly to the page's <main> element.
 *
 * Must be the first focusable element in the document. The matching
 * <main> needs `id="main-content"` and `tabIndex={-1}` so focus actually
 * lands there when the link is activated.
 */
const SkipLink = () => (
  <a
    href="#main-content"
    className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:px-4 focus:py-2 focus:bg-background focus:text-foreground focus:border focus:border-brass focus:rounded focus:shadow-lg focus:font-medium"
  >
    Skip to main content
  </a>
);

export default SkipLink;
